import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MaterialModule } from './modules/material.module';
import {HttpClientModule, HttpClient, HTTP_INTERCEPTORS} from '@angular/common/http';
import { FormsModule } from '@angular/forms';

import { ChooseFormComponent } from './components/choose-form/choose-form.component';
import { RpkComponent } from './components/rpk/rpk.component';
import { PeselValidatorDirective } from './validators/pesel-validator.directive';
import { NipValidatorDirective } from './validators/nip-validator.directive';
import { MailIdentityValidatorDirective } from './validators/mail-identity-validator.directive';
import { SummaryComponent } from './components/summary/summary.component';
import { ShareholdersComponent } from './components/shareholders/shareholders.component';
import { EntityComponent } from './components/entity/entity.component';
import { AssigneeComponent } from './components/assignee/assignee.component';
import { AttachmentsComponent } from './components/attachments/attachments.component';
import { MessageService } from "primeng/api";
import { ContactComponent } from './components/contact/contact.component';
import { SignComponent } from './components/sign/sign.component';
import { PartnersComponent } from './components/partners/partners.component';
import {AuthInterceptor} from "./services/auth.interceptor";
import { LoginComponent } from './components/login/login.component';
import { HomeComponent } from './components/home/home.component';
import { ProposalsListComponent } from './components/proposals-list/proposals-list.component';
import { ProposalSignedComponent } from './components/proposal-signed/proposal-signed.component';
import { SignResponseComponent } from './components/sign-response/sign-response.component';
import { RodoComponent } from './components/rodo/rodo.component';

@NgModule({
  declarations: [
    AppComponent,
    ChooseFormComponent,
    RpkComponent,
    PeselValidatorDirective,
    NipValidatorDirective,
    MailIdentityValidatorDirective,
    SummaryComponent,
    ShareholdersComponent,
    EntityComponent,
    AssigneeComponent,
    AttachmentsComponent,
    ContactComponent,
    SignComponent,
    PartnersComponent,
    LoginComponent,
    HomeComponent,
    ProposalsListComponent,
    ProposalSignedComponent,
    SignResponseComponent,
    RodoComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MaterialModule,
    HttpClientModule,
    FormsModule
  ],
  providers: [MessageService,
    {provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor,multi:true}
],
  bootstrap: [AppComponent]
})
export class AppModule {
}
